import { render } from "./Multicolumn.vue?vue&type=template&id=33ea0ad8"
import script from "./Multicolumn.vue?vue&type=script&lang=js"
export * from "./Multicolumn.vue?vue&type=script&lang=js"

import "./Multicolumn.vue?vue&type=style&index=0&id=33ea0ad8&lang=scss"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__